import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './baseQuery'
import { API_TAGS } from './tags'

/**
 * Единственный createApi в проекте.
 * Сущности добавляют свои ручки через baseApi.injectEndpoints в entities/*_/api.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: API_TAGS,
  endpoints: () => ({}),
})
